import type { OptionType } from '@atlaskit/select/types';

import type { FormOption, FormOptionField } from '../../types/form/form-fields';
import type { OptionsValue } from '../../types/form/form-fields/field-values';

export const findParent = (
	formOptionField: FormOptionField,
	currentValue?: OptionsValue,
): FormOption | undefined =>
	currentValue?.options.length
		? formOptionField.options.find(
				(option) => option.id === currentValue.options[0].id.split(':')[0],
			)
		: undefined;

export const findParentValue = (
	formOptionField: FormOptionField,
	currentValue?: OptionsValue,
): OptionType | null => {
	const parent = findParent(formOptionField, currentValue);
	return parent ? { value: parent.id, label: parent.label } : null;
};

export const findChildValue = (
	formOptionField: FormOptionField,
	currentValue?: OptionsValue,
): OptionType | null => {
	const parent = findParent(formOptionField, currentValue);
	if (parent && currentValue) {
		const child = currentValue.options[0].id.includes(':')
			? parent.children?.find((option) => option.id === currentValue.options[0].id.split(':')[1])
			: null;
		return child ? { value: child.id, label: child.label } : null;
	}
	return null;
};
